import React, { useEffect, useState } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import PropTypes from 'prop-types'

import AuthFlow from 'Pods/LazyLoaded/AuthModal/AuthFlow'
import { MODE } from 'Pods/LazyLoaded/AuthModal/constants'

import ensureMTCaptcha from 'Utils/ensureMTCaptcha'

import UserLogin from './Login'
import UserRegister from './Register'

function UserTabs({
  activeTabId = '',
  customId = '',
  source = '',
  captchaId = '',
  loadScripts = false,
  locale = 'en',
  newTopNavigation = false,
}) {
  // Controlled so the AuthFlow footer switch link can change the active tab.
  const [activeId, setActiveId] = useState(activeTabId || 'login')

  useEffect(() => {
    // MTCaptcha only backs the legacy password forms; the OTP flow has none.
    if (!loadScripts || newTopNavigation) {
      return undefined
    }

    const cleanup = ensureMTCaptcha()

    return cleanup
  }, [loadScripts, newTopNavigation])

  const loginTab = {
    title: 'Log in',
    id: 'login',
    expand: true,
    contents: newTopNavigation
      // Keyed by mode: both tabs render the same component type at the same
      // position, so without a key React reuses the instance and its internal
      // mode state would survive the tab switch.
      ? <AuthFlow key={MODE.LOGIN} mode={MODE.LOGIN} locale={locale} onSwitchMode={() => setActiveId('register')} />
      : <UserLogin customId={customId} captchaId={captchaId} locale={locale} />,
  }
  const registerTab = {
    title: 'Register',
    id: 'register',
    expand: true,
    contents: newTopNavigation
      ? <AuthFlow key={MODE.SIGNUP} mode={MODE.SIGNUP} locale={locale} onSwitchMode={() => setActiveId('login')} />
      : <UserRegister customId={customId} source={source} captchaId={captchaId} locale={locale} />,
  }

  return (
    <Tabs
      className="auth-tabs"
      expand
      activeTabId={activeId}
      onClick={setActiveId}
      tabs={[
        loginTab,
        registerTab,
      ]}
    />
  )
}

UserTabs.propTypes = {
  activeTabId: PropTypes.string,
  customId: PropTypes.string,
  source: PropTypes.string,
  captchaId: PropTypes.string,
  loadScripts: PropTypes.bool,
  locale: PropTypes.string,
  newTopNavigation: PropTypes.bool,
}

export default UserTabs
